ui-cms-legal-notice-dialog {
  sd-dialog::part(base) {
    z-index: 65538;
    overflow-y: scroll;
  }

  sd-dialog::part(panel) {
    max-height: 90vh;

    @media (min-width: 768px) {
      max-height: 60vh;
    }
  }
}
